import { useContext } from 'react'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import remarkGfm from 'remark-gfm'
import { GlobalDataContext, TemplateContext, evaluateTemplateValue } from '@ea-lab/reactive-json'

/**
 * MarkdownContent — renders its `content` prop (a markdown string) as HTML.
 *
 * A thin, GENERIC wrapper around react-markdown (already a project dependency) —
 * reactive-json ships no markdown renderer, and this capability is reusable by
 * any block or page (here it powers the dashboard "Note" widget). Styled with the
 * Tailwind `prose` recipe.
 *
 * `allowHtml` (default true) passes raw HTML in the source through to the page.
 * That is right for markdown an editor typed, and wrong for markdown produced by
 * something else — an attachment, an assistant transcript — where a `<script>` or
 * an `onerror` attribute would run on our own origin. Such callers pass false,
 * which leaves the tags escaped, exactly as the builder chat renders them.
 */
export const MarkdownContent = ({ props }) => {
  const globalDataContext = useContext(GlobalDataContext)
  const templateContext = useContext(TemplateContext)
  const raw = evaluateTemplateValue({ valueToEvaluate: props.content, globalDataContext, templateContext })
  const text = typeof raw === 'string' ? raw : (raw == null ? '' : String(raw))
  // Opt-OUT rather than opt-in: the widgets that already rely on raw HTML must
  // keep working without being edited.
  const allowHtml = props.allowHtml !== false

  return (
    <div className="prose prose-sm max-w-none text-gray-700 prose-headings:mt-1 prose-headings:mb-1.5 prose-p:my-1.5 prose-a:text-teal-700 prose-code:text-teal-700 prose-code:before:content-none prose-code:after:content-none">
      {text.trim()
        ? <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={allowHtml ? [rehypeRaw] : []}>{text}</ReactMarkdown>
        : <span className="text-gray-300 italic">Note vide — cliquez pour écrire…</span>}
    </div>
  )
}
